
// smart_ellipsis
// ------------------------------------

function smart_ellipsis(el, i) {
  const text = el.querySelectorAll('[data-js-smart-ellipsis-text]')[0];
  const style = el.getElementsByClassName('js-smart-ellipsis__style-tag')[0];

  function wrapper_width() {
    return el.getBoundingClientRect().width;
  }

  function text_width() {
    return text.getBoundingClientRect().width;
  }

  function animate_text(text_width, wrapper_width) {
    const distance = text_width - wrapper_width;
    text.classList.add(`js-smart-ellipsis__text-id-${i}`);
    text.style.cssText = `left: -${distance}px; transform: translate3d(${distance}px,0,0);`;
    style.innerHTML = `.c-content-tile:hover .js-smart-ellipsis__text-id-${i} { transition-duration: ${distance * 30}ms; }`;
  }

  function is_needed() {
    const current_text_width = text_width();
    const current_wrapper_width = wrapper_width();

    if (current_text_width > current_wrapper_width) {
      el.classList.add('js-smart-ellipsis--has-overflow', 'js-smart-ellipsis--enabled', `js-smart-ellipsis--id-${i}`);
      animate_text(current_text_width, current_wrapper_width);
    }
  }
  is_needed();

  window.addEventListener('resize', is_needed);
}


// init_all
// ------------------------------------

// Must wait for browser to layout the page before performing calculations
window.addEventListener('load', () => {
  function init_all() {
    const items = Array.from(document.querySelectorAll('[data-js-smart-ellipsis]'));
    items.forEach(smart_ellipsis);
  }
  init_all();
});
